import { Controller, useFormContext } from 'react-hook-form'

import { Checkbox } from '@/components/ui/checkbox'
import { classNames } from '@/utils/helpers'

import type { NewMessageUserFiltersFormValues } from './UsersListFilters'

interface Props {
  name: keyof NewMessageUserFiltersFormValues
  label: JSX.Element
  className?: string
}

export const UsersListFiltersField = ({ name, label, className }: Props) => {
  const form = useFormContext()

  return (
    <div
      className={classNames(
        'flex min-h-10 w-full items-center gap-2 leading-[22px]',
        className,
      )}
    >
      <Controller
        name={`${name}.isActive`}
        control={form.control}
        render={({ field: { value, onChange } }) => {
          return (
            <div className="flex h-[22px] items-center">
              <Checkbox
                checked={value}
                onCheckedChange={onChange}
                className="rounded-full border dark:border-secondary-300 dark:bg-secondary-400 data-[state=checked]:dark:bg-primary-500"
              />
            </div>
          )
        }}
      />
      {label}
    </div>
  )
}
